'use client'

import { createApi } from '@reduxjs/toolkit/query/react'

import { CamposEditablesConfiguracionReserva, ConfiguracionReserva } from '../interfaces/ConfiguracionReserva'

import { baseQuery } from '@/core/api/baseQuery'
import { GenericResponseOData } from '@/core/api/interfaces/GenericResponseOData'

// Nombres CLR exactos: OData publica el nombre de la propiedad, no el de la columna, y un $expand mal
// escrito no da error hasta que se mira la respuesta. Se expanden solo las tres navegaciones que el
// backend ya carga en su lista cacheada (Agrupacion, DiagramaEstadoReserva, MenuReserva): cualquier
// otra llegaría en null aunque el $expand la pida.
export const consultaConfiguracionReservas =
  '$filter=Eliminado eq false&$orderby=Nombre&$expand=MenuReserva,DiagramaEstadoReserva,Agrupacion'

export interface PatchConfiguracionReservaArgs {
  id: number
  cambios: Partial<CamposEditablesConfiguracionReserva>
}

export const configuracionReservasApi = createApi({
  reducerPath: 'configuracionReservasApi',
  baseQuery,
  tagTypes: ['ConfiguracionReserva'],
  endpoints: (builder) => ({
    getConfiguracionReservas: builder.query<ConfiguracionReserva[], void>({
      query: () => ({
        url: `/ConfiguracionReservas?${consultaConfiguracionReservas}`,
        method: 'GET',
      }),
      transformResponse: (respuesta: GenericResponseOData<ConfiguracionReserva[]>) => respuesta.value,
      providesTags: ['ConfiguracionReserva'],
    }),
    // PATCH y no PUT: manda solo lo que cambió y el backend acepta únicamente la plantilla y las cartas.
    patchConfiguracionReserva: builder.mutation<void, PatchConfiguracionReservaArgs>({
      query: ({ id, cambios }) => ({
        url: `/ConfiguracionReservas(${id})`,
        method: 'PATCH',
        body: cambios,
      }),
      invalidatesTags: ['ConfiguracionReserva'],
    }),
  }),
})

export const { useGetConfiguracionReservasQuery, usePatchConfiguracionReservaMutation } = configuracionReservasApi
